import type { ComponentType, ReactNode, SVGProps } from 'react';
import { cn } from '@/shared/lib/cn';

interface LiveStatTileProps {
  value: ReactNode;
  total?: ReactNode;
  label: ReactNode;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  actions?: ReactNode;
  isLoading?: boolean;
  animateIndex?: number | undefined;
  className?: string | undefined;
}

export const LiveStatTile = ({
  value,
  total,
  label,
  icon: Icon,
  actions,
  isLoading,
  animateIndex,
  className,
}: LiveStatTileProps) => (
  <div
    className={cn(
      'animate-rise-in flex flex-col gap-1.5 rounded-md bg-surface-raised p-3 shadow-card transition-shadow duration-300 hover:shadow-raised',
      className,
    )}
    style={animateIndex != null ? { animationDelay: `${animateIndex * 40}ms` } : undefined}
  >
    <span className="flex items-center gap-1.5 text-[11px] font-semibold uppercase leading-none tracking-[0.12em] text-ink-subtle">
      {Icon ? <Icon aria-hidden className="size-3.5" /> : null}
      {label}
    </span>
    <span className="font-display text-2xl font-semibold leading-none tabular-nums text-ink">
      {isLoading ? '—' : value}
      {!isLoading && total != null ? (
        <span className="ml-1 text-base font-medium text-ink-muted">/ {total}</span>
      ) : null}
    </span>
    {actions}
  </div>
);
